// NPM Imports
import React, { useContext, useState } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import MultiEINTableRow from './MultiEINTableRow'

// Asset Imports

export default function MultiEINTable() {
   const state = useQuoteContext()
   const { getString } = state

   // Get Permissions for EIN Integrations
   const integrationPermissions = state.featurePermissions['EINIntegrations']

   if (state.productPayrollEINCount > 0)
      return (
         <div className='row'>
            <div className='col'>
               <table className='table table-sm'>
                  <thead>
                     <tr>
                        {state.productPayrollEINCount > 0 && (
                           <>
                              <th className='grey-bold'>&nbsp;</th>
                              <th className='grey-bold'>
                                 {getString(
                                    'product.MultiEINTable.Header.EINName',
                                 )}
                              </th>
                           </>
                        )}
                        <th className='grey-bold'>
                           {getString('product.MultiEINTable.Header.EECount')}
                        </th>
                        <th className='grey-bold'>
                           {getString('global.Volume')}
                        </th>
                        <th className='grey-bold'>
                           {getString('global.Bundle')}
                        </th>
                        <th className='grey-bold'>
                           {getString(
                              'product.MultiEINTable.Header.StatesCount',
                           )}
                        </th>
                        {state.user_view !== 'External' && (
                           <th className='grey-bold'>
                              {getString(
                                 'product.MultiEINTable.Header.ImpType',
                              )}
                           </th>
                        )}
                        {state.user_view !== 'External' && (
                           <th className='grey-bold'>
                              {getString(
                                 'product.MultiEINTable.Header.ImpCost',
                              )}
                           </th>
                        )}
                        <th className='grey-bold'>
                           {getString(
                              'product.MultiEINTable.Header.StatesCost',
                           )}
                        </th>
                        <th className='grey-bold'>
                           {getString('global.Monthly')}
                        </th>
                        {(state.einIntegrationsCount > 0 ||
                           integrationPermissions.includes(
                              state.user_role,
                           )) && (
                           <th className='grey-bold'>
                              {getString(
                                 'product.MultiEINTable.Header.Integrations',
                              )}
                           </th>
                        )}
                     </tr>
                  </thead>
                  <tbody>
                     {
                        /*Uses the number of EIN Count to create MultiEINTableRow*/
                        Array.from(
                           { length: state.productPayrollEINCount },
                           (_, i) => i,
                        ).map((i) => (
                           <MultiEINTableRow key={i} index={i} />
                        ))
                     }
                  </tbody>
               </table>
            </div>
         </div>
      )
}
